import { Home, Mail, Users, Settings, Armchair } from 'lucide-react';
import type { ReactNode } from 'react';
import type { TabId } from './Sidebar';

interface Tab {
  id: TabId;
  label: string;
  icon: ReactNode;
}

interface BottomTabBarProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}

const tabs: Tab[] = [
  { id: 'home', label: 'Home', icon: <Home size={20} /> },
  { id: 'invites', label: 'Invites', icon: <Mail size={20} /> },
  { id: 'guests', label: 'Guests', icon: <Users size={20} /> },
  { id: 'table-plan', label: 'Table Plan', icon: <Armchair size={20} /> },
  { id: 'settings', label: 'Settings', icon: <Settings size={20} /> },
];

export function BottomTabBar({ activeTab, onTabChange }: BottomTabBarProps) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-background-card border-t border-border shadow-lg z-10">
      <div className="flex items-stretch h-14">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                relative flex flex-col items-center justify-center flex-1 gap-0.5
                active:bg-background-elevated transition-colors duration-150
                ${isActive ? 'text-primary' : 'text-text-secondary'}
              `}
            >
              <div className={`transition-transform duration-150 ${isActive ? 'scale-110' : 'scale-100'}`}>
                {tab.icon}
              </div>
              <span className="text-[10px] font-medium leading-tight">{tab.label}</span>
              <div className={`absolute bottom-0 left-1/2 -translate-x-1/2 h-0.5 bg-primary rounded-full transition-all duration-200 ${isActive ? 'w-8 opacity-100' : 'w-0 opacity-0'}`} />
            </button>
          );
        })}
      </div>
    </nav>
  );
}
